import Header from "./components/Header";
import LandingHeroSection from "./pages/LandingHeroSection";
import Why from "./pages/Why";
import Tokenomics from "./pages/Tokenomics";
import Features from "./pages/Features";
import About from "./pages/About";
import BuySection from "./pages/BuySection";
import Join from "./pages/Join";
import Footer from "./components/Footer";
import Tokenomic from "./pages/Tokenomic";
import { Route, Routes } from "react-router-dom";
import { Box } from "@mui/material";
function App() {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Box
                sx={{
                  backdropFilter: "blur(5px)",
                }}
              >
                <Header />
                <LandingHeroSection />
                {/* <Partners /> */}
                <About />
                <Why />
                <BuySection />

                <Tokenomics />
                <Tokenomic />
                <Features />
                <Join />
                <Footer />
              </Box>
            </>
          }
        />
      </Routes>
    </>
  );
}

export default App;
